<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Agregar No conformidad</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex>
                                <v-text-field label="Resumen"
                                              v-model="d.resumen"
                                              counter
                                              clearable
                                              maxlength="255"
                                              :error-messages="errores.collect('resumen')"
                                              v-validate="'required'"
                                              data-vv-name="resumen"
                                              required
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex>
                                <v-select label="Origen" hint="Origen de la no conformidad" :items="origenes" v-model="d.origen_id"
                                          item-value="id"
                                          item-text="desig"
                                          :error-messages="errores.collect('origen_id')"
                                          v-validate="'required'"
                                          data-vv-name="origen_id"
                                          required
                                          persistent-hint
                                ></v-select>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                        :close-on-content-click="false"
                                        v-model="menuFecha"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="d.fecha"
                                            label="Fecha"
                                            prepend-icon="event"
                                            readonly
                                            :error-messages="errores.collect('fecha')"
                                            v-validate="'required'"
                                            data-vv-name="fecha"
                                            required
                                    ></v-text-field>
                                    <v-date-picker locale="es-ar" v-model="d.fecha" @input="menuFecha = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        prepend-icon="person"
                                        clearable
                                        label="Gestor"
                                        item-value="id"
                                        item-text="name"
                                        v-model="d.gestor_id"
                                        :items="users"
                                        :error-messages="errores.collect('gestor_id')"
                                        v-validate="'required'"
                                        data-vv-name="gestor_id"
                                        required
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        prepend-icon="person"
                                        clearable
                                        label="Usuarios asignados"
                                        item-value="id"
                                        item-text="name"
                                        v-model="d.usuarios"
                                        :items="users"
                                        multiple
                                        :error-messages="errores.collect('usuarios')"
                                        v-validate="'required'"
                                        data-vv-name="usuarios"
                                        required
                                >
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex>
                                <empresa-select v-model="d.empresa_id" @change="empresaChange"></empresa-select>
                            </v-flex>
                            <v-flex v-if="d.origen_id === 1">
                                <micro-cliente-select v-model="d.cliente_id" :empresa="d.empresa_id"></micro-cliente-select>
                            </v-flex>
                            <v-flex v-if="d.origen_id === 1">
                                <micro-proveedor-select v-model="d.proveedor_id" :empresa="d.empresa_id"></micro-proveedor-select>
                            </v-flex>
                            <v-flex v-if="d.origen_id === 1">
                                <micro-item-select v-model="d.producto_id" :empresa="d.empresa_id" @change="itemChange"></micro-item-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="d.origen_id === 2">
                            <v-flex>
                                <v-text-field label="Proceso" v-model="d.proceso"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="d.origen_id === 3">
                            <v-flex>
                                <v-select
                                        label="Tipo de auditoría"
                                        :items="auditorias"
                                        v-model="d.auditoria_tipo"
                                ></v-select>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Requisito que incumple" v-model="d.incumplimiento"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm4 md3>
                                <v-autocomplete
                                        clearable
                                        label="Defectos"
                                        item-value="id"
                                        item-text="desig"
                                        v-model="d.defecto"
                                        :items="defectos"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4 md3>
                                <v-text-field label="Cantidad afectada" v-model="d.cant"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 md3>
                                <v-text-field :readonly="!!(d.producto_id)" label="Unidad" v-model="d.um"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green" dark :loading="loading" @click="guardar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import empresaSelect from '../../../components/EmpresaSelect';
    import microClienteSelect from '../../../components/MicroClienteSelect';
    import microProveedorSelect from '../../../components/MicroProveedorSelect';
    import microItemSelect from '../../../components/MicroItemSelect';
    import mixinIncidencia from '../../../mixins/calidad/incidencia';
    import usersMixin from '../../../mixins/auth/users';
    import usersDefecto from '../../../mixins/defecto';
    import {mapActions} from 'vuex';

    export default {
        name: "encabezado",
        $_veeValidate: {
            validator: 'new'
        },
        inject: ['$validator'],
        components: {empresaSelect, microClienteSelect, microProveedorSelect, microItemSelect},
        mixins: [mixinIncidencia, usersMixin, usersDefecto],
        data() {
            return {
                loading: false,
                origenes: [],
                auditorias: [
                    {text: 'Interna', value: 'i'},
                    {text: 'Externa', value: 'e'},
                ],
                d: {
                    origen_id: '',
                    empresa_id: '',
                    proveedor_id: '',
                    cliente_id: '',
                    proceso: '',
                    producto_id: '',
                    auditoria_tipo: '',
                    estado_id: 1,
                    resumen: '',
                    fecha: '',
                    sectores: [],
                    usuarios: [],
                    defecto_id: '',
                    cant: 0,
                    gestor_id: '',
                    um: ''
                },
                cliente: {},
                users: [],
                sectores: [],
                defectos: [],
                menuFecha: false
            }
        },
        mounted() {
            this.getUsers();
            this.getSectores();
            this.defectoAll(r => {
                this.defectos = r.defectos;
            }, err => console.error(err));
            this.incidenciaOrigenes(r => {
                this.origenes = r;
            }, err => {
                console.error(err)
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            itemChange(item) {
                this.d.um = (item) ? item.B1_UM : '';
            },
            empresaChange() {
                this.d.cliente_id = '';
                this.d.proveedor_id = '';
            },
            getSectores() {
                this.incidenciaSectores(r => {
                    this.sectores = r;
                }, err => {
                    console.error(err)
                })
            },
            getUsers() {
                this.usersList(r => {
                    this.users = r;
                }, err => {
                    console.log(err);
                });
            },
            guardar() {
                this.$validator.validateAll()
                    .then(r => {
                        if (r) {
                            this.loading = true;
                            this.incidenciaStore(this.d, r => {
                                this.$router.push('/calidad/no-conformidad/gestion/' + r.incidencia.id);
                                this.loading = false;
                            }, err => {
                                this.loading = false;
                                console.error(err)
                            })
                        } else {
                            this.msjShow({txt: 'Error de validación', tipo: 2});
                        }
                    })


            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/calidad/no_conformidad/add.vue